import React from 'react';
import { Route, Switch } from 'react-router';
import {connect} from 'react-redux'
import Categories from './Categories';
import Category from './Category';
import Item from './Category/Item';
import Feedback from './Feedback'
import {FAQModel} from '/app/src/model'

class Helpdesk extends React.Component {
    componentDidMount() {
        this.props.requestCategories()
        this.props.readItems()
    }

    render() {
        return (
            <Switch>
                <Route path='/clientChat/faq/helpdesk/category/:id/preview/:itemId?' component={Category}/>
                <Route path='/clientChat/faq/helpdesk/category/:id/:action/:itemId?' component={Item}/>
                <Route path='/clientChat/faq/helpdesk/category/:id' component={Category}/>
                <Route path='/clientChat/faq/helpdesk/feedback' component={Feedback}/>
                <Route component={Categories}/>
            </Switch>
        )
    }
}

const { dispatcher: dispatchGetCategories} = FAQModel.getCategoriesRequest()
const { dispatcher: readItems } = FAQModel.readItemsRequest()

const mapDispatchToProps = (dispatch, props) => ({
    requestCategories: () => dispatch(dispatchGetCategories()),
    readItems: () => dispatch(readItems())
})


export default connect(null, mapDispatchToProps)(Helpdesk)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/index.js